/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon32Regular = forwardRef('MediaAudioMicAIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 1a6 6 0 0 0-6 6v8a6 6 0 0 0 12 0V7a6 6 0 0 0-6-6Zm-4 6a4 4 0 0 1 8 0v8a4 4 0 0 1-8 0V7Z" }),
        React.createElement("path", { d: "M7 12.5a1 1 0 0 1 1 1V15a8 8 0 1 0 16 0v-1.5a1 1 0 1 1 2 0V15c0 5.185-3.947 9.449-9 9.95V28h4.5a1 1 0 1 1 0 2h-11a1 1 0 1 1 0-2H15v-3.05C9.947 24.45 6 20.186 6 15v-1.5a1 1 0 0 1 1-1Z" })));
});
